import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';

import { BroadcastViewerPage } from '../../../../../../../pages/broadcast-viewer';
import { CallPage } from '../../../../../../../pages/call';
import { ConferencesHistoryPage } from '../../../../../../../pages/conferences-history';
import { ConnectToMeetingByIdPage } from '../../../../../../../pages/connect-to-meeting-by-id';
import { CreateBroadcastPage } from '../../../../../../../pages/create-broadcast';
import { FeedbackPage } from '../../../../../../../pages/feedback';
import { CreateCallPage } from '../../../../../../../pages/main';
import { PlanCallPage } from '../../../../../../../pages/planning';
import { withErrorBoundary } from '../../../../../../helpers/hocs/with-error-boundary';
import { selectIsTelemessengerExpEnabled } from '../../../../../flags/selectors';

interface PagesProps {
    isPlanningDisabled?: boolean;
    onCallOverlayHide?: () => void;
    withChat?: boolean;
}

const PagesComponent: FunctionComponent<PagesProps> = ({ isPlanningDisabled, onCallOverlayHide, withChat }) => {
    const isTelemessengerExpEnabled = useSelector(selectIsTelemessengerExpEnabled);

    return (
        <Switch>
            <Route exact path="/">
                <CreateCallPage />
            </Route>
            <Route exact path="/connect-to-meeting-by-id">
                <ConnectToMeetingByIdPage />
            </Route>
            <Route exact path="/planning">
                {isPlanningDisabled ? <Redirect to="/" /> : <PlanCallPage />}
            </Route>
            <Route exact path="/broadcast-planning">
                {isPlanningDisabled ? <Redirect to="/" /> : <PlanCallPage isBroadcast />}
            </Route>
            <Route exact path="/create-broadcast">
                <CreateBroadcastPage />
            </Route>
            <Route exact path="/browser-auto-create">
                <CreateCallPage autoCreate />
            </Route>
            <Route path="/j/:id">
                <CallPage onOverlayHide={onCallOverlayHide} isChatAllowed={withChat} />
            </Route>
            {isTelemessengerExpEnabled && (
                <Route path="/private-join/:id">
                    <CallPage onOverlayHide={onCallOverlayHide} isChatAllowed={withChat} />
                </Route>
            )}
            <Route path="/live/:id">
                <BroadcastViewerPage />
            </Route>
            <Route path="/feedback">
                <FeedbackPage />
            </Route>
            <Route path="/conferences-history">
                <ConferencesHistoryPage />
            </Route>
        </Switch>
    );
};

export const Pages = withErrorBoundary(PagesComponent);
